module.exports = __webpack_public_path__ + "static/media/google_play_full.5ddda312.svg";